import {showMessage} from 'exsportia-components'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {useParams} from 'react-router-dom'

import {useBookingLoader} from '../../services/booking/hooks'
import {usePaymentProvider} from '../../services/payments/hooks/payment-provider-form.provider'
import {useLocale} from '../../utils/i18n'
import {SubscriptionBookingsMutations, SubscriptionBookingsQueries} from './index'
import {getMembershipCancelRequestErrorKey} from './membership-cancel-request-errors'
import {PaySubscriptionBookingForPayMuOp} from './mutations/create-subscription-booking-for-pay'
import {PayNextSubscriptionCycleMuOp} from './mutations/pay-next-subscription-cycle'
import {UpdateSubscriptionPaymentMethodMuOp} from './mutations/update-subscription-payment-method'

export const usePaySubscriptionBookingCyclesByOneTimePayment = (params?: PaySubscriptionBookingForPayMuOp) => {
  const {openPaymentForm} = usePaymentProvider()
  const {setIsLoading} = useBookingLoader()
  const {l} = useLocale()

  return useMutation(SubscriptionBookingsMutations.paySubscriptionBookingCyclesByOneTimePayment({
    onSuccess: (_, options) => {
      openPaymentForm?.({
        entity: 'subscription',
        bookingId: options.entityId,
        startProcessCallback: () => setIsLoading(true),
        totalPrice: options.totalPrice
      })
    },
    onError: () => {
      showMessage(l('somethingWentWrong'), 'error')
    },
    ...params
  }))
}
export const useUpdateSubscriptionPaymentMethod = (params?: UpdateSubscriptionPaymentMethodMuOp) =>
  useMutation(SubscriptionBookingsMutations.updateSubscriptionPaymentMethod(params))

export const usePayNextSubscriptionCycle = (params?: PayNextSubscriptionCycleMuOp) =>
  useMutation(SubscriptionBookingsMutations.payNextSubscriptionCycle(params))

export const useMembershipCancelRequests = (subscriptionId?: string) =>
  useQuery(SubscriptionBookingsQueries.getMembershipCancelRequests({params: subscriptionId}))

export const useCreateMembershipCancelRequest = () => {
  const {l} = useLocale()
  const queryClient = useQueryClient()

  return useMutation(SubscriptionBookingsMutations.createMembershipCancelRequest({
    onSuccess: (_, variables) => {
      showMessage(l('membershipCancel_sent'), 'success')
      queryClient.invalidateQueries(['getMembershipCancelRequests', variables.subscriptionId])
    },
    onError: (error) => {
      showMessage(l(getMembershipCancelRequestErrorKey(error)), 'error')
    },
  }))
}

export const useWithdrawMembershipCancelRequest = () => {
  const {l} = useLocale()
  const queryClient = useQueryClient()

  return useMutation(SubscriptionBookingsMutations.withdrawMembershipCancelRequest({
    onSuccess: (_, variables) => {
      showMessage(l('membershipCancel_withdrawn'), 'success')
      queryClient.invalidateQueries(['getMembershipCancelRequests', variables.subscriptionId])
    },
    onError: (error) => {
      showMessage(l(getMembershipCancelRequestErrorKey(error)), 'error')
    },
  }))
}

export const useSubscriptionBooking = (id?: string) => {
  const {subscriptionBookingId} = useParams()
  const idToUse = id || subscriptionBookingId

  return useQuery(SubscriptionBookingsQueries.getSubscriptionBooking({
    params: idToUse,
    enabled: Boolean(idToUse)
  }))
}
